import React from "react";

const FullScreenIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			{...props}>
			<path
				d="M3 15.75C3 16.1642 2.66421 16.5 2.25 16.5V16.5C1.83579 16.5 1.5 16.1642 1.5 15.75L1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5V10.5C2.66421 10.5 3 10.8358 3 11.25L3 15.75Z"
				fill="#EFF0F6"
			/>
			<path
				d="M3 6.75C3 7.16421 2.66421 7.5 2.25 7.5V7.5C1.83579 7.5 1.5 7.16421 1.5 6.75L1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5V1.5C2.66421 1.5 3 1.83579 3 2.25L3 6.75Z"
				fill="#EFF0F6"
			/>
			<path
				d="M15.75 15C16.1642 15 16.5 15.3358 16.5 15.75V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5L11.25 16.5C10.8358 16.5 10.5 16.1642 10.5 15.75V15.75C10.5 15.3358 10.8358 15 11.25 15L15.75 15Z"
				fill="#EFF0F6"
			/>
			<path
				d="M6.75 15C7.16421 15 7.5 15.3358 7.5 15.75V15.75C7.5 16.1642 7.16421 16.5 6.75 16.5L2.25 16.5C1.83579 16.5 1.5 16.1642 1.5 15.75V15.75C1.5 15.3358 1.83579 15 2.25 15L6.75 15Z"
				fill="#EFF0F6"
			/>
			<path
				d="M16.5 6.75C16.5 7.16421 16.1642 7.5 15.75 7.5V7.5C15.3358 7.5 15 7.16421 15 6.75L15 2.25C15 1.83579 15.3358 1.5 15.75 1.5V1.5C16.1642 1.5 16.5 1.83579 16.5 2.25L16.5 6.75Z"
				fill="#EFF0F6"
			/>
			<path
				d="M16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5V16.5C15.3358 16.5 15 16.1642 15 15.75L15 11.25C15 10.8358 15.3358 10.5 15.75 10.5V10.5C16.1642 10.5 16.5 10.8358 16.5 11.25L16.5 15.75Z"
				fill="#EFF0F6"
			/>
			<path
				d="M6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25V2.25C7.5 2.66421 7.16421 3 6.75 3L2.25 3C1.83579 3 1.5 2.66421 1.5 2.25V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5L6.75 1.5Z"
				fill="#EFF0F6"
			/>
			<path
				d="M15.75 1.5C16.1642 1.5 16.5 1.83579 16.5 2.25V2.25C16.5 2.66421 16.1642 3 15.75 3L11.25 3C10.8358 3 10.5 2.66421 10.5 2.25V2.25C10.5 1.83579 10.8358 1.5 11.25 1.5L15.75 1.5Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default FullScreenIcon;
